import { Link } from 'react-router-dom'
import { appConfig } from '@/shared/config/app-config'

export function Logo() {
  return (
    <Link to="/plan" className="flex items-center">
      <img
        src={appConfig.assets.logo}
        alt={appConfig.name}
        className="h-8 w-auto"
      />
    </Link>
  )
}
